import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const CanvasContextMenu = ({ open, x = 0, y = 0, items = [], onClose }) => {
    const [activeSubmenuKey, setActiveSubmenuKey] = useState('');

    useEffect(() => {
        if (!open) {
            setActiveSubmenuKey('');
            return undefined;
        }

        const handleMouseDown = (event) => {
            const target = event.target instanceof Element ? event.target : null;
            if (target?.closest('[data-free-canvas-context-menu="true"]')) return;
            onClose?.();
        };

        const handleWindowBlur = () => {
            onClose?.();
        };

        window.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('blur', handleWindowBlur);

        return () => {
            window.removeEventListener('mousedown', handleMouseDown);
            window.removeEventListener('blur', handleWindowBlur);
        };
    }, [onClose, open]);

    if (!open || items.length === 0) return null;

    return (
        <div
            className={styles.menu}
            style={{ left: x, top: y }}
            data-free-canvas-context-menu="true"
            onMouseLeave={() => setActiveSubmenuKey('')}
        >
            {items.map((item) => {
                if (item.type === 'divider') {
                    return <div key={item.key} className={styles.divider} />;
                }

                if (item.type === 'title') {
                    return (
                        <div key={item.key} className={styles.menuTitle}>
                            {item.label}
                        </div>
                    );
                }

                const hasChildren = Array.isArray(item.children) && item.children.length > 0;
                const submenuOpen = hasChildren && activeSubmenuKey === item.key;

                return (
                    <div
                        key={item.key}
                        className={styles.menuItemWrap}
                        onMouseEnter={() => {
                            if (hasChildren) {
                                setActiveSubmenuKey(item.key);
                            } else {
                                setActiveSubmenuKey('');
                            }
                        }}
                    >
                        <button
                            type="button"
                            className={`${styles.menuItem} ${item.disabled ? styles.menuItemDisabled : ''} ${submenuOpen ? styles.menuItemActive : ''}`}
                            onClick={() => {
                                if (item.disabled) return;
                                if (hasChildren) {
                                    setActiveSubmenuKey((prev) => (prev === item.key ? '' : item.key));
                                    return;
                                }
                                item.onClick?.();
                                onClose?.(); 
                            }}
                        >
                            <span className={styles.menuItemMain}>
                                {item.icon ? (
                                    <img
                                        src={item.icon}
                                        alt=""
                                        width={18}
                                        height={18}
                                        className={styles.menuItemIcon}
                                    />
                                ) : null}
                                <span className={styles.menuItemLabel}>{item.label}</span>
                            </span>
                            {hasChildren ? (
                                <span className={styles.menuItemArrow}>{'>'}</span>
                            ) : (
                                item.shortcut ? <span className={styles.menuItemShortcut}>{item.shortcut}</span> : null
                            )}
                        </button>
                        {submenuOpen ? (
                            <div className={styles.submenu}>
                                {item.children.map((child) => (
                                    <button
                                        key={child.key}
                                        type="button"
                                        className={`${styles.submenuItem} ${child.disabled ? styles.menuItemDisabled : ''}`}
                                        onClick={() => {
                                            if (child.disabled) return;
                                            child.onClick?.();
                                            onClose?.();
                                        }}
                                    >
                                        <span className={styles.menuItemLabel}>{child.label}</span>
                                    </button>
                                ))}
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
};

export default CanvasContextMenu;
